module.exports = {
      id: "panoramic-link-icon-usage",
      viewBox: "0 0 20 14",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#panoramic-link-icon",
      toString: function () {
        return this.url;
      }
    }